import _ from 'underscore';
import { I18nModel } from '@bingads-webui-universal/i18n-model';

export class I18nModelClone extends I18nModel {
  constructor({
    i18nToClone,
    newTranslationData,
    overrideLocale,
    overrideTimeZone,
    overrideCurrency,
  }) {
    super(_.defaults({
      loadTranslationData: () => (newTranslationData),
      failFast: false,
      // This clone builds its OWN resource from a complete static dictionary, so it must not
      // inherit a sparse parent's missingTranslationFallback: 'key' -- that would make unknown
      // symbolic keys (e.g. Schema_Enum_*) resolve to themselves instead of undefined, which
      // the legacy shims rely on for their default-value fallbacks.
      missingTranslationFallback: 'none',
      locale: overrideLocale || i18nToClone.locale,
      timeZone: overrideTimeZone || i18nToClone.timeZone,
      currency: overrideCurrency || i18nToClone.currency,
    }, i18nToClone));
  }
}
